import { ActionIconDef, GridConfig, GridRow } from '@inavista/components/grid';

// Out of Office request popup → Other: the request's "other" days (category + duration) on @inavista/components. The rows
// are the request popup's own list (LocalRowsGridApi), edited, added and removed here and saved with the request, as
// before. Same columns, categories, Delete command, Add button and "Total duration" footer as the Syncfusion grid it
// replaces.

export const OTHER_VACATIONS_URL = 'page://other-vacations';
export const ADD_OTHER_ACTION = 'add-other';
export const DELETE_OTHER_ACTION = 'delete';

const BLACK = '#000000de';
const INACTIVE = '#cccccc';
const PLUS_ICON = '<line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />';
const TRASH_ICON = '<polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />';

export const OTHER_CATEGORIES = [
  'Conference', 'Business Trip', 'Attending Trade Show', 'Attending Training Event', 'Traveling', 'Working Elsewhere',
  'Jury Duty', 'Other',
];

// uId is the popup's row key; id and vrfId were hidden and out of the column chooser.
export const OTHER_VACATIONS_COLUMNS: [string, string][] = [
  ['uId', 'int'],
  ['id', 'int'],
  ['vrfId', 'nvarchar'],
  ['category', 'nvarchar'],
  ['days', 'int'],
];

const READ_ONLY = 'This request can no longer be changed';

export function otherVacationsActionIcons(canEdit: boolean): ActionIconDef[] {
  return [{
    key: DELETE_OTHER_ACTION, label: 'Delete', icon: TRASH_ICON,
    colorFn: () => (canEdit ? BLACK : INACTIVE),
    disabledFn: () => !canEdit,
    labelFn: () => (canEdit ? 'Delete' : READ_ONLY),
  }];
}

export function otherVacationsGridConfig(canEdit: boolean): GridConfig {
  return {
    apiBaseUrl: OTHER_VACATIONS_URL,
    clientSide: true,
    keyColumn: 'uId',
    rowHeight: 26,
    defaultColumnOrder: ['category', 'days'],
    hiddenByDefaultColumns: ['uId', 'id', 'vrfId'],
    columnLabels: { category: 'Category', days: 'Duration' },
    // RIMS grid look: headers left; the category left, the duration (days) right.
    columnAlign: {
      category: { header: { horizontal: 'left' } },
      days: { horizontal: 'right', header: { horizontal: 'left' } },
    },
    columnWidths: { category: 320, days: 160 },
    stretchColumns: true,
    columnNumberFormats: { days: { maximumFractionDigits: 0 } },
    // The old footer: "Total duration: <sum>".
    totals: { days: { of: 'sum', label: 'Total duration' } },
    totalsPlacement: 'row',
    excelFilterColumns: ['category'],
    editMode: canEdit ? 'inline' : 'none',
    editSaveMode: 'row',
    editTrigger: 'click',
    editableColumns: canEdit ? ['category', 'days'] : [],
    editorOptions: { category: OTHER_CATEGORIES.map(c => ({ value: c, label: c })) },
    requiredColumns: canEdit ? ['days'] : [],
    // The old checks: a duration is a whole number from 1 to 365.
    rowValidator: (row: GridRow) => {
      const days = Number(row['days']);
      if (!Number.isInteger(days) || days < 1) return { column: 'days', message: "Value can't be 0 or empty." };
      if (days > 365) return { column: 'days', message: 'A duration is at most 365 days.' };
      return null;
    },
    deleteMode: 'host',
    rowDeletable: () => false,
    toolbarActions: canEdit ? [{ key: ADD_OTHER_ACTION, label: 'Add', kind: 'button', icon: PLUS_ICON }] : [],
    enableColumnsPicker: true,
    enableSearch: false,
    enableExport: false,
    enableRefresh: false,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableResetLayout: true,
    enableFooter: false,
    enableContextMenuFilter: true,
    emptyStateMessage: canEdit ? 'No other days yet. Use Add to enter one.' : 'No other days on this request.',
    persistenceKey: 'rims.out-of-office.other-days',
    persistenceVersion: 1,
  };
}
